import { getURLSearchParams } from './getURLSearchParams';

const URL_PARAMETER_REGEX = new RegExp(/\/mortgage\/dashboard\/([a-zA-Z0-9\-]+)\/?/gi);

export type GetLoanIDFromURLResult = {
    loanID: string | null;
    isQueryParameter: boolean;
};

// One for the whole path, one for the group
const EXPECTED_MATCHES = 2;

/**
 * Gets the loan ID from a URL, supporting both query parameter and URL parameter loan ID
 */
export const getLoanIDFromURL = (path: string): GetLoanIDFromURLResult => {
    const queryParams = getURLSearchParams(path);
    const [matches] = [...path.matchAll(URL_PARAMETER_REGEX)];
    const urlParamLoanID = (matches?.length ?? 0) < EXPECTED_MATCHES ? null : matches[1];
    const queryParamLoanID = queryParams.get('loanID');
    return {
        loanID: queryParamLoanID ?? urlParamLoanID,
        isQueryParameter: !!queryParamLoanID,
    };
};
